<template>
  <el-container>
    <el-main>
      <el-row>
        <el-col>
          <p>Usuarios con acceso</p>
          <el-form ref="form" :model="currentRole" label-width="90px">
            <el-form-item label-width="0">
              <el-table
                :data="filterData"
                style="width: 100%"
                height="250"
                v-loading="loading"
              >
                <el-table-column width="60" fixed align="center">
                  <template slot="header" slot-scope="scope">
                    <i class="el-icon-setting" :key="scope.$index"></i>
                  </template>
                  <template slot-scope="scope">
                    <el-button
                      icon="el-icon-minus"
                      circle
                      size="mini"
                      type="danger"
                      :key="scope.$index"
                      @click="removeUser(scope.row)"
                      :disabled="
                        scope.row.EmployeeID == scope.row.CalendarCreatedBy
                      "
                    ></el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="FullName" label="Nombre" min-width="200">
                </el-table-column>
                <el-table-column label="Permitir Editar" align="center">
                  <template slot-scope="scope">
                    <el-switch
                      v-model="scope.row.canEdit"
                      @change="toggleEditPermission(scope.row)"
                      :disabled="
                        scope.row.EmployeeID == scope.row.CalendarCreatedBy
                      "
                    ></el-switch>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: "RemoveShareCalendar",
  components: {},
  props: ["calendarID", "usersInCalendar"],
  data() {
    return {
      keySearch: "FullName",
      loading: false,
      innerDrawer: false,
      form: {
        search: null
      },
      drawer: false,
      currentRole: {}
    };
  },
  computed: {
    filterData() {
      var filterable = [];
      let getTypeParams = typeof this.form.search;
      if (getTypeParams != "object") {
        if (this.form.search.trim().length == 0) {
          // input filter with blanck value
          filterable = this.usersInCalendar;
        } else {
          if (this.form.search !== null) {
            filterable = this.usersInCalendar.filter((data) => {
              const value = data[this.keySearch];
              const valueType = typeof value;

              if (valueType === "number") {
                return value.toString() === this.form.search;
              }

              return (
                !this.form.search ||
                data[this.keySearch]
                  .toLowerCase()
                  .includes(this.form.search.toLowerCase())
              );
            });
          } else {
            filterable = this.usersInCalendar;
          }
        }
      } else {
        filterable = this.usersInCalendar;
      }

      return filterable;
    }
  },
  methods: {
    removeUser(user) {
      this.$emit("remove-user", user);
    },
    toggleEditPermission(user) {
      this.$emit("toggle-edit", user);
    }
  }
};
</script>

<style></style>
